class WebSocketPrinter {
  static init(inputDocuments, printdocumentMixin) {
    console.log(`inside constructor..${printdocumentMixin}`);
    this.defaults = {
      url: 'ws://127.0.0.1:12212/printer',
      onConnect() {
      },
      onDisconnect() {
      },
      onUpdate() {
      },
    };
    this.printDocumentMixinObj = printdocumentMixin;
    if (!this.isConnected()) {
      this.websocket = null;
      this.connected = false;
      this.connect(printdocumentMixin);
    }
    this.printDocuments = inputDocuments;
    console.log('inside init ', this.printDocumentMixinObj);
  }

  // init() {
  //   this.connect();
  // }

  // static onMessage(evt) {
  //   console.log('inside onMessage..');
  //   this.settings.onUpdate(evt.data);
  // }

  // static onConnect() {
  //   console.log('inside onConnect..');
  //   this.connected = true;
  //   this.settings.onConnect();
  // }

  // static onDisconnect() {
  //   console.log('inside onDisconnect..');
  //   this.connected = false;
  //   this.settings.onDisconnect();
  //   this.reconnect();
  // }
  static setConnected(data) {
    console.log('data in set connected..', data);
    this.connected = data;
  }

  static connect(printdocumentMixin) {
    console.log('inside connect..');
    console.log('inside connect ', this.printDocumentMixinObj);
    console.log('inside connect param', printdocumentMixin);
    const mixinObj = this;
    mixinObj.data = this.printDocumentMixinObj;
    this.websocket = new WebSocket(this.defaults.url);
    this.websocket.onopen = function (event) {
      WebSocketPrinter.setConnected(true);
    };
    this.websocket.onclose = function (event) {
      WebSocketPrinter.setConnected(false);
      WebSocketPrinter.reconnect(mixinObj.data);
    };
    // this.websocket.onmessage = async function (event) {
    //   await WebSocketPrinter.defaults.onUpdate(event.data);
    // };
    console.log('mixinObj log', mixinObj);
    console.log('mixinObj data', mixinObj.data);
    this.websocket.onmessage = async function (event) {
      console.log(`onMesssage arrived 1 ${mixinObj}`);
      console.log(`mixin obj data ${mixinObj.data}`);
      console.log(`mixin obj data ${printdocumentMixin}`);

      await WebSocketPrinter.onCustomUpdate(mixinObj.data, event.data, mixinObj);
    };
  }

  static reconnect(printdocumentMixin) {
    this.connect(printdocumentMixin);
  }

  static submit(printdocumentMixin) {
    // console.log('inside submit..', data);
    const dgDocuments = [
      'air_dg_to_ship_to',
      'air_dg_to_forwarder',
      'fedex_laser',
      'imo_dg_to_ship_to',
      'imo_dg_to_forwarder'];


    const curDocuments = this.printDocuments.filter(document => !dgDocuments.includes(document.type));
    if (!curDocuments.length) {
      const mixinObj = this;
      mixinObj.data = printdocumentMixin;
      WebSocketPrinter.onCustomUpdate(printdocumentMixin, undefined, mixinObj);
    } else {
      this.websocket.send(JSON.stringify(
        curDocuments.map(document => ({
          type: document.printer_type ? document.printer_type.toUpperCase() : 'ZEBRA',
          qty: document.no_copies || 1,
          url: document.document_url,
          filter: '',
        }))));
    }
  }

  static async onCustomUpdate(printdocumentMixin, data, mixinObj) {
    // console.log('inside socket this ', this);
    // console.log('inside socket temp ', temp);

    console.log('onCustomUpdate arrived 2 ');
    console.log(`onCustomUpdate arrived 2 Mixin${printdocumentMixin}`);
    let parse;
    if (data) {
      parse = JSON.parse(data);
    }
    if (parse && parse.status === 1) {
      printdocumentMixin.$errorMessage({ message: parse.message });
    } else if (parse) {
      printdocumentMixin.$successMessage({ message: parse.message });
    }
    const dgDocuments = [
      'air_dg_to_ship_to',
      'air_dg_to_forwarder',
      'fedex_laser',
      'ups_laser',
      'imo_dg_to_ship_to',
      'imo_dg_to_forwarder',
    ];
    console.log('outside print Documents call');
    console.log('printDocuments', mixinObj.printDocuments);
    console.log(mixinObj.printDocuments);
    if (mixinObj.printDocuments && mixinObj.printDocuments.filter(document => dgDocuments.includes(document.type)).length) {
      console.log('inside print Documents call');
      // prompt message to proceed after loading applicable DG paper
      const hasConfirm = await printdocumentMixin.$PromptAlert('Please load applicable DG paper', 'Proceed ?', {
        dangerouslyUseHTMLString: true,
        showCancelButton: false,
        confirmButtonText: 'Proceed',
      });
      console.log('hasconfirm passed');
      console.log('hasconfirm passed');
      if (hasConfirm) {
        mixinObj.websocket.send(JSON.stringify(
          mixinObj.printDocuments.filter(document => dgDocuments.includes(document.type))
            .map(curDocument => ({
              type: curDocument.printer_type ? curDocument.printer_type.toUpperCase() : 'ZEBRA',
              qty: curDocument.no_copies || 1,
              url: curDocument.document_url,
              filter: '',
            }))));
        mixinObj.printDocuments = undefined;
      }
    }
  }

  static isConnected() {
    return WebSocketPrinter.connected;
  }
}

export default WebSocketPrinter;
